import { UploadFile } from "../../../models/attachment";

export class AddingDeviceModel {
    serialNumber: string = "";
    nomenclature: string = "";
    validatedInErp: boolean;
    
    index: number;
    isValid: boolean;

    uploadAttachments: UploadFile[] = [];
}